import * as yup from 'yup'
import { trimmedInputValues, capitalizeWordsInValue } from '../utils';

const ConversionProbabilityValidationSchema = yup.object().shape({
    conversionProbability: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('This field is required.'),
    conversionRemarks: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('This field is required.'),
})

const ConversionProbabilityInitialState = {
    conversionProbability: '',
    conversionRemarks: '',
}

export { ConversionProbabilityValidationSchema, ConversionProbabilityInitialState }; 